const AIDesk = {
  "结束会话": "대화 종료",
  "转人工服务": "상담사 연결",
  "跳转": "열기",
  "立即填写": "지금 작성하기",
  "已提交": "제출됨",
  "提交": "제출",
  "查看内容": "내용 보기",
  "请填写必填项": "필수 항목을 작성해 주세요.",
  "请输入内容": "내용을 입력해 주세요.",
  "如果满意请给好评哦～": "서비스에 대해 평가해 주세요.",
  "请对本次服务进行评价": "이번 서비스에 대해 평가해 주세요.",
  "提交评价": "평가 제출",
  "并发限制": "현재 접속자가 많아 서비스 이용이 지연되고 있습니다. 잠시 후 다시 시도해 주세요.",
  "分支选项异常": "옵션에 문제가 있습니다. 설정을 확인해 주세요.",
  "服务评价": "서비스 평가",
  "满意": "만족",
  "不满意": "불만족",
  "感谢您的反馈，我们会持续优化改进": "피드백 감사합니다. 지속적으로 개선하겠습니다.",
  "您遇到了哪方面的问题": "어떤 문제가 발생했나요?",
  "其他反馈内容": "기타 의견",
  "取消": "취소",
  "答非所问": "질문과 무관한 답변",
  "未匹配相关内容": "관련 없는 내용",
  "信息错误": "정보 오류",
  "上下文理解错误": "문맥 이해 오류",
  "格式不规范": "올바르지 않은 형식",
  "内容不完整": "불완전한 내용",
  "file 大小超过 100MB，无法发送": "파일 크기가 100MB를 초과하여 전송할 수 없습니다.",
  "image 大小超过 20MB，无法发送": "이미지 크기가 20MB를 초과하여 전송할 수 없습니다.",
  "video 大小超过 100MB，无法发送": "동영상 크기가 100MB를 초과하여 전송할 수 없습니다.",
  "提交成功": "제출 완료",
  "userID 只能包含可打印 ASCII 字符": "userID에는 인쇄 가능한 ASCII 문자만 사용할 수 있습니다.",
  "userID 不能包含'administrator'": "userID에는 'administrator' 문자열을 포함할 수 없습니다.",
  "userID 长度不能超过45字节": "userID 길이는 45바이트를 초과할 수 없습니다.",
  "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "해당 답변에 만족하지 않으신 이유와 더 나은 답변이 무엇인지 알려주세요.",
  "该回复由AI生成，内容仅供参考": "해당 답변은 AI가 생성한 내용으로 참고용입니다.",
  "排队等待中": "대기 중",
  "排队等待话术": "현재 모든 상담원이 상담 중입니다. 곧 연결해 드리겠습니다. 기다려 주셔서 감사합니다.",
  "当前前方排队人数": "현재 대기 인원",
  "结束排队": "대기 취소",
  "评价提交超过3分钟，无法更改。感谢您的反馈！": "리뷰는 제출 후 3분이 지나면 수정할 수 없습니다.",
  "不能发送空白消息": "빈 메시지를 보낼 수 없습니다",
  "确认转人工": "상담사 연결",
}
export default AIDesk;
